// import routes from './routes'
import * as documentsStore from './store'

export function documentModule({ app, router, store }) {
    // routes.forEach(route => {
    //     const {children, ...r} = route
    //     router.addRoute(r)
    //     if (children) {
    //         children.forEach(c => {
    //             router.addRoute(r.name, c)
    //         })
    //     }
    // })
    store.registerModule('documents', {...documentsStore, namespaced: true, })
}

export const PERMISSION = 'contracts'

export const IS_BETA = true